<template>
  <div
    :class="[
      $style.item,
      item.highlighted && $style.itemHighlighted
    ]"
    @click="$emit('click', $event)"
    :data-testid="item.testid || item.name"
  >
    <b-svg
      v-if="iconLeft"
      v-bind="iconLeft"
      :class="$style.iconLeft"
    />
    <p
      :class="[
        $style.text,
        {[$style.selected]: item.selected}
      ]"
    >
      <slot>{{ item.name }}</slot>
      <b-svg v-if="svgIconRight"
             :name="svgIconRight.name"
             :class="$style.iconRight"
             :size="svgIconRight.size"
             :color="svgIconRight.color"
      />
    </p>
    <b-svg
      v-if="item.selected"
      :class="$style.checked"
      name="tick"
      height="24"
    />
  </div>
</template>

<script>
export default {
  props: {
    iconLeft: {
      type: Object,
      required: false,
    },

    svgIconRight: {
      type: Object,
      required: false,
    },

    item: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" module>
.item {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 12px 0;
  position: relative;
  user-select: none;

  &Highlighted {
    position: relative;

    &:after {
      content: '';
      width: calc(100% + 40px);
      height: 100%;
      position: absolute;
      left: -20px;
      top: 0;
      background-color: $color-gray-15;
    }
  }
}

.iconLeft {
  margin-right: 12px;
  z-index: 1;
}

.iconRight {
  margin-left: 12px;
  z-index: 1;
}

.text {
  display: flex;
  align-items: center;
  line-height: 1.5rem;
  flex: 1;
  padding-right: 10px;
  z-index: 1;
}

.selected {
  font-weight: 600;
}

.checked {
  position: absolute;
  margin-right: 8px;
  right: -22px;
  z-index: 1;
}
</style>
